import { createMuiTheme } from '@material-ui/core';

import { colors } from '../../theme/colors';

const themePicker = createMuiTheme({
  palette: {
    primary: {
      light: colors.green3,
      main: colors.green1,
      dark: colors.green2,
      contrastText: colors.white,
    },
    secondary: {
      light: colors.green3,
      main: colors.green1,
      dark: colors.green2,
      contrastText: colors.white,
    },
  },
  overrides: {
    MuiInputAdornment: {
      root: {
        color: colors.gray3,
        marginTop: -4,
      },
    },
    MuiOutlinedInput: {
      input: {
        cursor: 'pointer',
      },
      adornedEnd: {
        cursor: 'pointer',
      },
      root: {
        '&$focused $notchedOutline': {
          borderColor: colors.green1,
        },
      },
      notchedOutline: {
        borderColor: colors.gray3,
      },
      focused: {},
    },
    MuiTextField: {
      root: {
        width: '100%',
        fontSize: '0.875',
        color: colors.gray2,
      },
    },
    MuiFormLabel: {
      root: {
        fontSize: '1rem',
        color: colors.gray2,
        '&$focused': {
          color: colors.green1,
        },
      },
    },
  },
});

export { themePicker };
